import React, { Component } from "react";
import { shape, bool, string } from "prop-types";
import classNames from "classnames";

import Image from "pages/_components/Image";
import I18n from "pages/_components/I18n";
import FieldError from "pages/_components/fields/FieldError";
import EnvironmentTag from "pages/_components/EnvironmentTag";
import {
    CORPORATE_PH_ENVIRONMENT_TYPE,
    CORPORATE_ENVIRONMENT_TYPE,
    CORPORATE_GROUP_ENVIRONMENT_TYPE,
    NEW_ENROLLMENT_ENVIRONMENT_TYPE,
    RETAIL_ENVIRONMENT_TYPE,
} from "../../constants";

class Enviroments extends Component {
    static propTypes = {
        disabled: bool,
        environments: shape([]).isRequired,
        field: shape({}).isRequired,
        form: shape({}).isRequired,
        activeEnvironment: shape({}),
        fromSetDefaultEnvironmentPage: bool,
        userData: shape({}),
        legendTextID: string,
    };

    static defaultProps = {
        activeEnvironment: {},
        disabled: false,
        fromSetDefaultEnvironmentPage: false,
        userData: {},
        legendTextID: "settings.changeEnvironment",
    };

    state = {
        envSelected: null,
    };

    handleClick = (value) => {
        const { field, form } = this.props;
        form.setFieldValue(field.name, value);
        this.setState({ envSelected: value });
    };

    getEnvironmentItem = ({ allowedToAccess, environment, id }) => {
        const { activeEnvironment, disabled, fromSetDefaultEnvironmentPage, userData } = this.props;
        const { envSelected } = this.state;
        const environmentToCheck = fromSetDefaultEnvironmentPage ? userData.idDefaultEnvironment : activeEnvironment.id;
        return (
            <>
                <div
                    className={`c-control c-control--radio ${envSelected === id ? "selected" : ""} ${
                        !allowedToAccess && !fromSetDefaultEnvironmentPage ? "env-disabled" : ""
                    }`}
                    key={id}>
                    <input
                        disabled={(!allowedToAccess && !fromSetDefaultEnvironmentPage) || disabled}
                        defaultChecked={Number(id) === environmentToCheck}
                        id={`environment-${id}`}
                        type="radio"
                        name="environment"
                        className="c-control-input"
                        onClick={() => this.handleClick(id)}
                    />
                    <label className="c-control-label c-control-label--environment" htmlFor={`environment-${id}`}>
                        <EnvironmentTag name={environment.name} type={environment.environmentType} />
                    </label>
                </div>
                {!allowedToAccess && !fromSetDefaultEnvironmentPage && (
                    <div className="environtment-disabled-message mt-5">
                        <Image src="images/warningIcon.svg" className="svg-icon" />
                        <I18n id="administration.restrictions.unavailableEnvironment" />
                    </div>
                )}
            </>
        );
    };

    getEnvironmentList = (environmentType, defaultTitle) => {
        const { environments, activeEnvironment } = this.props;

        const environmentsFilteredByType = environments.filter((environment) => {
            const current = environment[1];
            const isActive = activeEnvironment.id === parseInt(current.idEnvironment, 10);
            return current.environmentType === environmentType && !isActive;
        });

        return (
            environmentsFilteredByType.length > 0 && (
                <>
                    <I18n
                        componentProps={{ className: "mb-5 mt-8" }}
                        component="h2"
                        id={`global.users.environmentType.${environmentType}`}
                        defaultValue={defaultTitle}
                    />
                    {environmentsFilteredByType.map(([id, environment]) => {
                        const allowedToAccess = environment.allowedToAccess.toString() === "true";
                        return this.getEnvironmentItem({ allowedToAccess, environment, id });
                    })}
                </>
            )
        );
    };

    getEnvironmentList = (environmentType1, environmentType2, defaultTitle) => {
        const { environments, activeEnvironment } = this.props;

        const environmentsFilteredByType = environments.filter((environment) => {
            const current = environment[1];
            const isActive = activeEnvironment.id === parseInt(current.idEnvironment, 10);
            return (
                (current.environmentType === environmentType1 || current.environmentType === environmentType2) &&
                !isActive
            );
        });

        return (
            environmentsFilteredByType.length > 0 && (
                <>
                    <I18n
                        componentProps={{ className: "mb-5 mt-8" }}
                        component="h2"
                        id={`global.users.environmentType.${environmentType1}`}
                        defaultValue={defaultTitle}
                    />
                    {environmentsFilteredByType.map(([id, environment]) => {
                        const allowedToAccess = environment.allowedToAccess.toString() === "true";
                        return this.getEnvironmentItem({ allowedToAccess, environment, id });
                    })}
                </>
            )
        );
    };

    getEnvironmentList = (environmentType1, environmentType2, environmentType3, defaultTitle) => {
        const { environments, activeEnvironment } = this.props;

        const environmentsFilteredByType = environments.filter((environment) => {
            const current = environment[1];
            const isActive = activeEnvironment.id === parseInt(current.idEnvironment, 10);
            return (
                (current.environmentType === environmentType1 || current.environmentType === environmentType2 || current.environmentType === environmentType3) &&
                !isActive
            );
        });

        return (
            environmentsFilteredByType.length > 0 && (
                <>
                    <I18n
                        componentProps={{ className: "mb-5 mt-8" }}
                        component="h2"
                        id={`global.users.environmentType.${environmentType1}`}
                        defaultValue={defaultTitle}
                    />
                    {environmentsFilteredByType.map(([id, environment]) => {
                        const allowedToAccess = environment.allowedToAccess.toString() === "true";
                        return this.getEnvironmentItem({ allowedToAccess, environment, id });
                    })}
                </>
            )
        );
    };

    render() {
        const {
            legendTextID,
            form: { errors },
            field,
        } = this.props;

        return (
            <fieldset className={classNames("form-group", { "has-error": errors[field.name] })}>
                {legendTextID && (
                    <div>
                        <I18n id={legendTextID} component="legend" componentProps={{ className: "visually-hidden" }} />
                    </div>
                )}

                <div className="selection-list blue-extralight-list">
                    {this.getEnvironmentList(RETAIL_ENVIRONMENT_TYPE, "Personal")}

                    {this.getEnvironmentList(
                        CORPORATE_PH_ENVIRONMENT_TYPE,
                        CORPORATE_ENVIRONMENT_TYPE,
                        NEW_ENROLLMENT_ENVIRONMENT_TYPE,
                        "Empresarial",
                    )}

                    {this.getEnvironmentList(CORPORATE_GROUP_ENVIRONMENT_TYPE, "Grupo económico")}
                </div>

                {errors[field.name] && (
                    <div className="text-center">
                        <FieldError error={errors[field.name]} />
                    </div>
                )}
            </fieldset>
        );
    }
}

export default Enviroments;
